<div class="sip-main-wrapper">
    <div class="img-container">
        <img class="sf-pitch-img" [src]="info?.topBannerImg">
    </div>
    <div class="content">
        <span class="tax-benifit-badge">
            <mat-icon class="icon">star</mat-icon><span class="text-details">TAX BENEFIT</span>
        </span>
        <span class="title">
            {{info?.title}}
        </span>
        <span class="desc">
            {{info?.desc}}
        </span>
    </div>
    <div class="bird-img">
        <img class="sf-pitch-img" [src]="info?.birdImg">
    </div>
    <button class="donate-cta" mat-button (click)="redirectTo()">Donate Now</button>
</div>